import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef, } from 'primeng/dynamicdialog';
import { BonusService } from '../../bonus.service';
import { Constants } from 'src/app/shared/utils/constants';
import { NgForm } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import Decimal from 'decimal.js';
import { ConfirmPromotionComponent } from './confirm-promotion/confirm-promotion.component';
import { LogDetailOverview, SentEmailItem } from '../promotion-bonus.type';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-bonus-setting-detail',
  templateUrl: './bonus-setting-detail.component.html',
  styleUrls: ['./bonus-setting-detail.component.sass'],
  providers: [DialogService],
})
export class BonusSettingDetailComponent implements OnInit {
  searchDetailText = '';
  logMode: 'overview' | 'detail' = 'overview';

  constructor(
    private configDialog: DynamicDialogConfig,
    private bonusService: BonusService,
    private refDialog: DynamicDialogRef,
    private appService: AppService,
    private dialogService: DialogService,
  ) {}

  bonus: any = {};
  bonusReset: any = {};
  listTarget = [];
  result: any = {};
  viewBonus: any = { conditions: [] };
  rateOrigin = null;
  isEdit = true;
  isStartValid = false;
  filterList = [];
  oldData: any = {};
  logHistory = [];
  detailsOfSentEmailsParams = {
    logId: '',
    page: 1,
    email: '',
    page_size: '10'
  };
  sentMailList: SentEmailItem[] = [];
  sentMailListPageInfo = {
    page: 1,
    page_size: 10,
    total: 0
  };
  statusOfEmail = {
    1: {
      label: 'Sending',
      color: '#EE6D9B'
    },
    2: {
      label: 'Sending',
      color: '#EE6D9B'
    },
    3: {
      label: 'Done',
      color: '#16AB8E'
    },
    4: {
      label: 'Failed',
      color: '#D6412F'
    }
  };
  @ViewChild('formSetting') formSetting: NgForm;
  groupByIdData = [];
  rawLogs = [];
  currentItemDetail: any;
  isResendProcessing = false;
  isExpired = false;
  detailOfLogOverview: LogDetailOverview = {
    totalRecords: 0,
    failed: 0,
    sending: 0,
    done: 0,
  };
  logs = [];
  bonusType = ['Normal', 'Before', 'After', ''];
  rawForm = {} as any;
  rawForm2: any;
  targetChange = false;

  ngOnInit(): void {
    this.initForm();
    this.getRate('usdjpy');
    this.convertOldData();
    this.rawForm = structuredClone(this.configDialog.data?.data?.bonus_event);
    this.rawForm2 = JSON.stringify(this.configDialog.data?.data?.bonus_event);
    this.bonus = this.configDialog.data?.data?.bonus_event;
    this.isExpired = this.configDialog.data.status === 'Expired';
    this.bonus.email = this.bonus.user.email;
    this.bonus.user_id = this.bonus.user.id;
    this.bonus.start_time = new Date(this.bonus.start_time);
    this.bonus.end_time = new Date(this.bonus.end_time);
    this.bonus.data.deposit.dfw = this.bonus.data.deposit.distance_from_withdraw / 86400000;
    this.onLoadData();
    this.logs = this.configDialog?.data?.data.logs;
    this.logs.forEach(item => {
      item.new = item?.email_sended?.sended_mail.filter(t => t.status === 1);
      item.done = item?.email_sended?.sended_mail.filter(t => t.status === 3);
      item.failed = item?.email_sended?.sended_mail.filter(t => t.status === 4);
      item.sending = item?.email_sended?.sended_mail.filter(t => t.status === 2);
      item.totalReceivers = item?.email_sended?.sended_mail.reduce((a, c) => a + c.total_email, 0);
    });
    this.activeDate();
  }

  status() {
    return this.configDialog.data.status === 'Expired';
  }

  convertOldData() {
    this.oldData = JSON.parse(
      JSON.stringify(this.configDialog.data?.data?.bonus_event)
    );
    this.oldData.start_time = new Date(this.oldData.start_time);
    this.oldData.end_time = new Date(this.oldData.end_time);
    this.oldData.email = this.oldData?.user?.email;
    this.oldData.user_id = this.oldData?.user?.id;
    //this.oldData.data.deposit.up_limit = this.oldData.data.deposit?.up_limit?.toString();
  }

  activeDate() {
    this.isStartValid = this.bonus.start_time?.getTime() <= new Date().getTime();
  }

  timeoutSelector = () => {
    const v = [];
    for (let i = 0; i <= 100; i++) {
      v.push(i);
    }
    return v;
  };

  diff_object(obj1, obj2) {
    let result: any = {};
    let obj1_flat = this.flatten_object(obj1);
    let obj2_flat = this.flatten_object(obj2);
    const combined_keys = [
      ...new Set([...Object.keys(obj1_flat), ...Object.keys(obj2_flat)]),
    ];

    for (let key of combined_keys) {
      const val1 =
        obj1_flat[key] instanceof Date
        ? obj1_flat[key].getTime()
        : obj1_flat[key];
      const val2 =
        obj2_flat[key] instanceof Date
        ? obj2_flat[key].getTime()
        : obj2_flat[key];
      if (val1 !== val2) {
        result[key] = {
          old_value: obj1_flat[key],
          new_value: obj2_flat[key],
        };
      }
    }
    return result;
  }

  flatten_object(obj) {
    let result = {};
    for (let key in obj) {
      // check typeof obj[key] === 'object' and not is null or Date
      if (
        typeof obj[key] === 'object' &&
        obj[key] !== null &&
        !(obj[key] instanceof Date)
      ) {
        let temp = this.flatten_object(obj[key]);
        for (let key2 in temp) {
          result[key + '_' + key2] = temp[key2];
        }
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  }

  onSelectData(): void {
    this.targetChange = true;
    this.bonus.email = this.bonus?.user?.email;
    this.bonus.user_id = this.bonus?.user?.user_id;
  }

  onLoadData() {
    this.bonusService.searchLevelOneByName({ q: '' }).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.listTarget = res.data;
      }
    });
  }

  onUpdateRateUJ(key, index): void {
    if (key === 'conditions') {
      const baseValue = this.bonus.data.deposit.conditions[index].threshold;
      this.viewBonus.conditions[index].threshold = +(
        baseValue / this.rateOrigin
      ).toFixed(2);
    } else {
      this.viewBonus[key] = (
        this.bonus.data.deposit.up_limit / this.rateOrigin
      ).toFixed(2);
    }
  }

  getRate(baseSymbol): void {
    const option = {
      symbol: baseSymbol,
    };
    this.bonusService.getRateBySymbol(option).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.rateOrigin = res.data.rate;
        this.bonus.data.deposit.conditions.forEach((item, i) => {
          this.onUpdateRateUJ('conditions', i);
          this.onUpdateRateUJ('up_limit_usd', i);
          let rate = new Decimal(item.rate).mul(100);
          item.rate = rate;
        });
        // console.log(mixConditions);
        for (let item of this.bonusReset.data?.deposit?.conditions) {
          if (this.bonus.data.deposit.conditions.length < 4) {
            this.bonus.data.deposit.conditions.push(item);
          }
        }
        //this.bonus.data.deposit.conditions = this.generateConditionRecord(mixConditions)
      }
    });
  }

  submitSetting() {
    let validEmail = false;

    if (!this.formSetting.valid || this.bonus.name?.trim().length === 0) {
      this.appService.showError('Please enter param setting bonus');
      return;
    }
    const body = JSON.parse(JSON.stringify(this.bonus));
    body.name = this.bonus.name?.trim();
    body.start_time = new Date(this.bonus.start_time).getTime();
    body.end_time = new Date(this.bonus.end_time).getTime();
    if (body.start_time > body.end_time) {
      this.appService.showError(
        'Start time is less than or equal to end time.'
      );
      return;
    }
    if (!body.is_enable_account && !body.is_enable_deposit) {
      this.appService.showError(
        'Either Bonus on Deposit or Bonus On Open Account method must be set to ON'
      );
      return;
    }
    body.data.deposit.multiple_time = body.data.deposit.multiple_time ? 1 : 0;
    body.data.deposit.distance_from_withdraw = 86400000 * +body.data.deposit.dfw;
    const mixConditions = [];
    // if (body.is_enable_deposit) {
    body.data.deposit.conditions.map((f) => {
      if (f.threshold && f.threshold !== '') {
        f.threshold = +f.threshold;
      }
      if (f.threshold === '') {
        f.threshold = null;
      }
      if (f.threshold !== null && f.threshold >= 0 && f.rate && f.rate > 0) {
        f.rate = +(f.rate / 100).toFixed(2);
        mixConditions.push(f);
      }
    });
    // handle show message
    const mixRates = body.data.deposit.conditions.filter(
      (f) => f.rate && f.rate > 0
    );
    const mixThreshold = body.data.deposit.conditions.filter(
      (f) => f.threshold !== null && f.threshold >= 0
    );

    if (
      mixConditions.length !== mixRates.length ||
      mixConditions.length !== mixThreshold.length
    ) {
      this.appService.showError('Please enter param setting bonus');
      return;
    }
    const [c1, c2, c3, c4] = body.data.deposit.conditions;
    const sync1 = c2.threshold && !c1.threshold;
    const sync20 = c3.threshold && !c1.threshold && !c2.threshold;
    const sync21 = c3.threshold && !c1.threshold;
    const sync22 = c3.threshold && !c2.threshold;
    const sync30 =
      c4.threshold && !c1.threshold && !c2.threshold && !c3.threshold;
    const sync31 =
      c4.threshold && !c1.threshold && !c2.threshold && c3.threshold;
    const sync32 =
      c4.threshold && !c3.threshold && !c2.threshold && c1.threshold;
    const sync33 =
      c4.threshold && c2.threshold && c3.threshold && !c1.threshold;
    const sync34 =
      c4.threshold && c1.threshold && c3.threshold && !c2.threshold;
    const sync35 =
      c4.threshold && c1.threshold && c2.threshold && !c3.threshold;
    const sync36 =
      c4.threshold && c2.threshold && !c1.threshold && !c3.threshold;

    if (sync36) {
      this.appService.showError(
        'Condition 1 & Condition 3 entry is required'
      );
      return;
    }
    if (sync35) {
      this.appService.showError('Condition 3 entry is required');
      return;
    }
    if (sync32) {
      this.appService.showError(
        'Condition 2 & Condition 3 entry is required'
      );
      return;
    }
    if (sync30) {
      this.appService.showError(
        'Condition 1 & Condition 2 & Condition 3 entry is required'
      );
      return;
    }
    if (sync20 || sync31) {
      this.appService.showError(
        'Condition 1 & Condition 2 entry is required'
      );
      return;
    }
    if (sync22 || sync34) {
      this.appService.showError('Condition 2 entry is required');
      return;
    }
    if (sync1 || sync33 || sync21) {
      this.appService.showError('Condition 1 entry is required');
      return;
    }

    const [
      { threshold: t1 },
      { threshold: t2 },
      { threshold: t3 },
      { threshold: t4 },
    ] = body.data.deposit.conditions;
    if (t1 && t2 && !t3 && !t4 && !(t1 < t2) && body.is_enable_deposit) {
      this.appService.showError(
        'Amount conditions entry rule: Condition 1 < Condition 2'
      );
      return;
    }
    if (
      t1 &&
      t2 &&
      t3 &&
      !t4 &&
      !(t1 < t2 && t2 < t3) &&
      body.is_enable_deposit
    ) {
      this.appService.showError(
        'Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3'
      );
      return;
    }
    if (
      t1 &&
      t2 &&
      t3 &&
      t4 &&
      !(t1 < t2 && t2 < t3 && t3 < t4) &&
      body.is_enable_deposit
    ) {
      this.appService.showError(
        'Amount conditions entry rule: Condition 1 < Condition 2 < Condition 3 < Condition 4'
      );
      return;
    }
    // }
    // else {
    //   delete body.data.deposit.up_limit;
    //   delete body.data.deposit.conditions;
    // }

    //body.data.deposit.conditions = mixConditions;
    // if (!body.is_enable_account) {
    //   delete body.data.open_account.usd_bonus;
    //   delete body.data.open_account.jpy_bonus;
    // }
    body.send_email_to = [];
    // check user_id null
    if (body.user_id === null || body.user === '') {
      this.appService.showError('Please enter target person setting bonus');
      //this.targetName = undefined;
      return;
    }
    const changedData = structuredClone(body);
    delete changedData?.send_email_to;
    changedData.end_time = new Date(changedData.end_time).toJSON();
    changedData.start_time = new Date(changedData.start_time).toJSON();
    changedData.data.deposit.conditions = changedData.data.deposit.conditions.filter(l => l.rate || l.threshold);
    const filterConditions = l => {
      if (l.rate && l.rate < 1) {
        l.rate = String(l.rate * 100);
      }
    };

    changedData.data.deposit.conditions.forEach(filterConditions);

    if (!changedData.is_enable_deposit) {
      const currentForm = JSON.parse(this.rawForm2);
      const cData = structuredClone(changedData);
      delete currentForm.data.deposit;
      delete cData.email;
      delete cData.data.deposit;
      delete cData.data.bonus_type;
      delete currentForm.data.bonus_type;
      const changedForm = JSON.stringify(cData);
      if (JSON.stringify(currentForm) === changedForm) {
        return this.appService.showWarning('No data changed');
      }
    }
    if (!changedData.is_enable_account && changedData.is_enable_deposit) {
      const currentForm = structuredClone(this.rawForm);
      const cData = structuredClone(changedData);
      delete currentForm.data.open_account;
      delete currentForm.email;
      delete cData.data.open_account;
      currentForm.data.deposit.conditions = (currentForm.data.deposit.conditions || []).filter(l => l.rate || l.threshold);
      const changedForm = JSON.stringify(cData);
      if (JSON.stringify(currentForm) === changedForm) {
        return this.appService.showWarning('No data changed');
      }
    }
    const f2 = JSON.parse(this.rawForm2);
    f2.data.deposit.conditions.forEach(filterConditions);
    const v = JSON.parse(JSON.stringify(changedData));

    v.user = {
        id: v.user.user_id || v.user_id,
        email: v.user.email,
        first_name: v.user.first_name,
        middle_name: v.user.middle_name,
        last_name: v.user.last_name,
    };
    if(v.is_enable_deposit) {
      v.data.deposit.dfw = +v.data.deposit.dfw
      v.data.deposit.up_limit = +v.data.deposit.up_limit
    }
    delete v.user.level;
    delete v.email;
    delete v.user.user_id;
    /*console.log(JSON.stringify(f2));
    console.log(JSON.stringify(v));*/
    if (JSON.stringify(f2) === JSON.stringify(v)) {
      return this.appService.showWarning('No data changed');
    }

    this.result = this.diff_object(this.oldData, body);
    const dialog = this.dialogService?.open(ConfirmPromotionComponent, {
      header: 'Confirm',
      showHeader: false,
      width: '50%',
      data: {
        campaignName: this.bonus.name,
        targetUserEmail: this.bonus.email,
        target: this.result,
        bonus: this.bonus,
        viewBonus: this.viewBonus,
        rateOrigin: this.rateOrigin
      },
    });
    body.data.deposit.conditions = body.data.deposit.conditions.filter((it) => it.rate && it.threshold);

    this.bonusService.previewMailData = body;
    dialog?.onClose.subscribe({
      next: ({ send_email_to, email_change_promotion_content, email_old_target_promotion_content, email_new_target_promotion_content }) => {
        const template = {
          ...(email_change_promotion_content && { email_change_promotion_content }),
          ...(email_old_target_promotion_content && { email_old_target_promotion_content }),
          ...(email_new_target_promotion_content && { email_new_target_promotion_content }),
        };
        if (send_email_to) {
          Object.assign(body, { send_email_to, ...template });
          this.saveSetting(body);
        } else {
          this.cancel();
        }
      },
    });
    //this.saveSetting(body);


  }

  rePatchForAccount(e) {
    if(!e) {
      const lv = (JSON.parse(this.rawForm2)).data.open_account;
      this.bonus.data.open_account.jpy_bonus = lv.jpy_bonus;
      this.bonus.data.open_account.usd_bonus = lv.usd_bonus;
    }
  }

  rePatchChild(e) {
    if (!e) {
      const lv = (JSON.parse(this.rawForm2)).data.deposit.conditions;
      for (let i = 0; i < 4; i++) {
        if (!lv[i]) {
          lv[i] = {
            rate: null,
            threshold: null
          };
        } else {
          lv[i].rate = lv[i].rate * 100;
        }
      }
      this.bonus.data.deposit.conditions = lv;
    }
  }

  /*depositChange() {
    const fcv = {
      ...this.bonus,
      end_time: typeof this.bonus.end_time === 'string' ? this.bonus.end_time : this.bonus.end_time.toJSON(),
      start_time: typeof this.bonus.end_time === 'string' ? this.bonus.end_time : this.bonus.start_time.toJSON(),
    }
    console.log(fcv);
    console.log(this.rawForm);
  }*/

  saveSetting(body) {
    this.bonusService.updateBonusEvents(this.bonus.id, body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Campaign data updated successfully');
        this.refDialog.close(true);
      }
    });
  }

  cancel() {
    this.bonus.data.bonus_type = this.oldData?.data?.bonus_type;
    this.bonus.data.deposit.dfw = this.oldData?.data?.deposit?.dfw;
    this.bonus.data.deposit.up_limit = this.oldData?.data?.deposit?.up_limit;
    this.bonus.data.open_account.jpy_bonus = this.oldData?.data?.open_account?.jpy_bonus;
    this.bonus.data.open_account.usd_bonus = this.oldData?.data?.open_account?.usd_bonus;
    this.bonus.email = this.oldData?.email;
    this.bonus.user_id = this.oldData?.user_id;
    this.bonus.end_time = new Date(this.oldData?.end_time);
    this.bonus.start_time = new Date(this.oldData?.start_time);
    this.bonus.name = this.oldData?.name;
    this.bonus.is_enable_account = this.oldData?.is_enable_account;
    this.bonus.is_enable_deposit = this.oldData?.is_enable_deposit;
    this.bonus.data.deposit.multiple_time = this.oldData?.data?.deposit?.multiple_time;
    this.bonus.user = this.oldData?.user;
    const f1 = this.bonus.data.deposit.conditions;
    const f2 = this.oldData?.data?.deposit?.conditions;
    f1[0].threshold = f2[0]?.threshold;
    f1[1].threshold = f2[1]?.threshold;
    f1[2].threshold = f2[2]?.threshold;
    f1[3].threshold = f2[3]?.threshold;
    //

    f1[0].rate = f2[0]?.rate;
    f1[1].rate = f2[1]?.rate;
    f1[2].rate = f2[2]?.rate;
    f1[3].rate = f2[3]?.rate;
    this.bonus.data.deposit.conditions.forEach((item, i) => {
      this.onUpdateRateUJ('conditions', i);
      this.onUpdateRateUJ('up_limit_usd', i);
      if (item.rate) {
        let rate = new Decimal(item.rate).mul(100);
        item.rate = rate;
      }

    });
    //this.bonus.data.deposit.conditions = this.generateConditionRecord(mixConditions);
    this.isEdit = true;
  }

  back() {
    if (this.configDialog) {
      this.refDialog.close(true);
    }
  }

  filterEmail(event: any) {
    let filtered = [];
    for (let i = 0; i < this.listTarget.length; i++) {
      let country = this.listTarget[i];
      if (
        country.email.toLowerCase().indexOf(event.query?.toLowerCase()) == 0
      ) {
        filtered.push(country);
      }
    }
    this.filterList = filtered;
  }

  initForm(): void {
    //  this.targetName = undefined;
    // this.targetControl.setValue(null);
    this.bonusReset = {
      is_enable_account: true,
      is_enable_deposit: true,
      data: {
        deposit: {
          up_limit: null,
          conditions: [
            {
              rate: null,
              threshold: null,
            },
            {
              rate: null,
              threshold: null,
            },
            {
              rate: null,
              threshold: null,
            },
            {
              rate: null,
              threshold: null,
            },
          ],
          dfw: 1,
          multiple_time: 0,
        },
        open_account: {
          jpy_bonus: null,
          usd_bonus: null,
        },
        bonus_type: 0,
      },
      start_time: null,
      end_time: null,
      email: '',
      user_id: null,
    };
    this.viewBonus = {
      up_limit_usd: null,
      conditions: [
        {
          threshold: null,
        },
        {
          threshold: null,
        },
        {
          threshold: null,
        },
        {
          threshold: null,
        },
      ],
    };
  }

  setSearchTerm() {
    if (this.searchDetailText || this.searchDetailText.length > 0) {
      this.detailsOfSentEmailsParams.email = this.searchDetailText.trim();
    } else {
      delete this.detailsOfSentEmailsParams.email;
    }
  }

  openDetails(item: any) {
    this.currentItemDetail = item;
    this.setSearchTerm();
    this.detailsOfSentEmailsParams.logId = String(item.id);
    this.logMode = 'detail';
    this.getDetail();
  }

  getDetail() {
    this.bonusService.getDetails(this.detailsOfSentEmailsParams).subscribe({
      next: ({ data: { items, status_report, paging } }) => {
        this.sentMailList = items;
        this.sentMailListPageInfo = paging;
        const totalRecords = status_report.reduce((a, c) => a + c.total_email, 0);
        const done = status_report.find(t => t.status === 3);
        const failed = status_report.find(t => t.status === 4);
        const processing = status_report.find(t => t.status === 2);
        const justCreated = status_report.find(t => t.status === 1);
        const sending = (processing ? processing.total_email : 0) + (justCreated ? justCreated.total_email : 0);
        this.detailOfLogOverview = {
          totalRecords,
          done: done ? done.total_email : 0,
          failed: failed ? failed.total_email : 0,
          sending
        };
      }
    });
  }

  refresh() {
    delete this.detailsOfSentEmailsParams.email;
    this.searchDetailText = '';
    this.detailsOfSentEmailsParams.page = 1;
    this.sentMailListPageInfo.page = 1;
    this.getDetail();
  }

  searchDetails() {
    this.sentMailListPageInfo.page = 1;
    this.detailsOfSentEmailsParams.page = 1;
    this.setSearchTerm();
    this.getDetail();
  }


  pageChanged(page: number) {
    this.sentMailListPageInfo.page = page;
    this.detailsOfSentEmailsParams.page = page;
    this.setSearchTerm();
    this.getDetail();
  }

  resendAll() {
    this.isResendProcessing = true;
    this.bonusService.resendAll(+this.detailsOfSentEmailsParams.logId).pipe(
      finalize(() => {
        this.isResendProcessing = false;
      })
    ).subscribe({
      next: () => {
        this.appService.showSuccess(`Resend All Successful!`);
      }
    });
  }

  resendOne(id: number) {
    this.isResendProcessing = true;
    this.bonusService.resendOne(+id).pipe(
      finalize(() => {
        this.isResendProcessing = false;
      })
    ).subscribe({
      next: () => {
        this.appService.showSuccess(`Resend Successful!`);
      }
    });
  }

  onBackToLogs() {
    this.logMode = 'overview';
    this.searchDetailText = '';
    this.pageChanged(1);
  }
}
